import React, { useEffect, useState } from "react";
import ProgressBar from "react-customizable-progressbar";
import fastinginprogressbg from "../../assets/images/dasboard/fastinginprogressbg.png";
import { Link } from "react-router-dom";
import StreakSection from "./StreakSection";

const FastingInProgress = ({
  dashboardData,
  setIsFastingTrue,
  fastingeatingduration,
  postFastingApi,
}) => {
  const [progress, setProgress] = useState(80);
  const windowType = dashboardData?.fastingtrack?.type;
  const activeWindowType = dashboardData?.fastingtrack?.activeWindow;
  const initialTime = fastingeatingduration || {
    hours: 0,
    minutes: 0,
    seconds: 0,
    completedPercentage: 0,
    eating_hours: 0,
    fasting_hours: 0,
  };
  const [time, setTime] = useState(initialTime);
  const total_time = time.hours * 3600 + time.minutes * 60 + time.seconds;
  const fastingStreek = dashboardData.fastingstrick.fastiStrickweeDay;
  // console.log(fastingStreek.thursday);
  useEffect(() => {
    let direction = "increase";

    if (windowType === "start") {
      const totalSeconds = time.hours * 3600 + time.minutes * 60 + time.seconds;
      let elapsedTime = 0;

      const interval = setInterval(() => {
        setTime((prevTime) => {
          if (direction === "increase") {
            const newSeconds = prevTime.seconds + 1;
            if (newSeconds === 60) {
              const newMinutes = prevTime.minutes + 1;
              return {
                hours: prevTime.hours + Math.floor(newMinutes / 60),
                minutes: newMinutes % 60,
                seconds: 0,
                completedPercentage: prevTime.completedPercentage, // Preserve additional properties
              };
            }
            return { ...prevTime, seconds: newSeconds };
          } else if (direction === "decrease") {
            if (
              prevTime.hours === 0 &&
              prevTime.minutes === 0 &&
              prevTime.seconds === 0
            ) {
              clearInterval(interval);
              return prevTime;
            }

            const newSeconds = prevTime.seconds - 1;
            if (newSeconds < 0) {
              const newMinutes = prevTime.minutes - 1;
              if (newMinutes < 0) {
                return {
                  hours: prevTime.hours - 1,
                  minutes: 59,
                  seconds: 59,
                  completedPercentage: prevTime.completedPercentage,
                };
              }
              return {
                ...prevTime,
                minutes: newMinutes,
                seconds: 59,
                completedPercentage: prevTime.completedPercentage,
              };
            }
            return { ...prevTime, seconds: newSeconds };
          }
        });

        // Update progress
        elapsedTime += direction === "increase" ? 1 : -1;
        const currentSeconds =
          time.hours * 3600 + time.minutes * 60 + time.seconds;
        const currentProgress = Math.min(
          Math.max((elapsedTime / totalSeconds) * 100, 0),
          100
        );
        setProgress(initialTime.completedPercentage);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [time]);
  // console.log(initialTime);

  return (
    <>
      <div className="clik-selfie-inline">
        <div>
          <div className="circleplayer">
            <div
              className="circleplayer1 circleLayerPause1 cursor-pointer"
              onClick={() => {
                postFastingApi();
              }}
            >
              <ProgressBar
                strokeWidth={28}
                strokeColor="#28F1C1"
                strokeLinecap="round"
                trackStrokeWidth={8}
                className="circleplayer2 z-20"
                radius={100}
                progress={progress}
                cut={180}
                rotate={-180}
              ></ProgressBar>
              <div className="circleplayer3  circleLayerPause3 cursor-pointer z-10">
                <Link
                  to="/fastingdesh"
                  onClick={() => {
                    setIsFastingTrue(false);
                  }}
                >
                  <div className="palyerdes pauseInProgress">
                    <i
                      className={`fa fa-${
                        windowType === "start" ? "pause" : "play"
                      }`}
                      aria-hidden="true"
                      style={{ color: "#fff" }}
                    ></i>
                  </div>
                </Link>
              </div>
            </div>
          </div>
          <div
            className="desbase mb-5 -mt-[60px] xl:-mt-[236px] lg:-mt-[197px] md:-mt-[170px] sm:-mt-[100px]"
            style={{
              backgroundImage: "url(" + fastinginprogressbg + ")",
            }}
          >
            <img
              loading="lazy"
              src={fastinginprogressbg}
              alt="no-food"
              className="deshimg opacity-25"
            />
          </div>
          <StreakSection
            fastingStreek={fastingStreek}
            time={time}
            dashboardData={dashboardData}
            initialTime={initialTime}
          />
        </div>
        {/* <div className='selfie-person'>
              <img src={SelfieImage} height={496} width={259} alt='Selfie' />
            </div> */}
      </div>
    </>
  );
};

export default FastingInProgress;
